export default "__VITE_ASSET__0b0a1f22__"